import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';
import { useDispatch } from 'react-redux';

function useTranslate() {
  const dispatch = useDispatch();
  const translateText = async (data) => {
    try {
      const response = await AxiosConfig.create('post', '/translate/')
        .call(data)
        .getResponseData();
      if (response?.status > 300) {
        const messageError = `Error: ${response?.status} - ${response?.message}: Translate`;
        dispatch(
          setSnackBar({ open: true, message: messageError, color: 'error' })
        );
      } else {
        dispatch(setSnackBar({ open: false, message: null, color: null }));
      }
      return {
        translatedText: response?.data,
        res: {
          status: response?.code,
          statusText: response?.message,
        },
      };
    } catch (error) {
      const messageError = `Error: ${error}: Translate`;
      dispatch(
        setSnackBar({ open: true, message: messageError, color: 'error' })
      );
    }
  };
  return {
    translateText,
  };
}

export default useTranslate;
